export const closeModal= () => {
	const upgradeModal = document.getElementById('upgrade-modal');
	const closeModal = document.getElementById('close-modal');
	closeModal.addEventListener('click', function() {
		upgradeModal.classList.add('hidden');
	});
}
